(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[223],{

/***/ 2637:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function ArrowRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 9204:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function ArrowTopRightOnSquareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.25 5.5a.75.75 0 00-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 00.75-.75v-4a.75.75 0 011.5 0v4A2.25 2.25 0 0112.75 17h-8.5A2.25 2.25 0 012 14.75v-8.5A2.25 2.25 0 014.25 4h5a.75.75 0 010 1.5h-5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.194 12.753a.75.75 0 001.06.053L16.5 4.44v2.81a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h2.553l-9.056 8.194a.75.75 0 00-.053 1.06z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ArrowTopRightOnSquareIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 4393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function CodeBracketIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.28 5.22a.75.75 0 010 1.06L2.56 10l3.72 3.72a.75.75 0 01-1.06 1.06L.97 10.53a.75.75 0 010-1.06l4.25-4.25a.75.75 0 011.06 0zm7.44 0a.75.75 0 011.06 0l4.25 4.25a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.06-1.06L17.44 10l-3.72-3.72a.75.75 0 010-1.06zM11.377 2.011a.75.75 0 01.612.867l-2.5 14.5a.75.75 0 01-1.478-.255l2.5-14.5a.75.75 0 01.866-.612z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CodeBracketIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 8685:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function CurrencyEuroIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.798 7.45c.512-.67 1.135-.95 1.702-.95s1.19.28 1.702.95a.75.75 0 001.192-.91C12.637 5.55 11.596 5 10.5 5s-2.137.55-2.894 1.54A5.205 5.205 0 006.83 8H5.75a.75.75 0 000 1.5h.77a6.333 6.333 0 000 1h-.77a.75.75 0 000 1.5h1.08c.183.528.442 1.023.776 1.46.757.99 1.798 1.54 2.894 1.54s2.137-.55 2.894-1.54a.75.75 0 00-1.192-.91c-.512.67-1.135.95-1.702.95s-1.19-.28-1.702-.95a3.505 3.505 0 01-.343-.55h1.795a.75.75 0 000-1.5H8.026a4.835 4.835 0 010-1h2.224a.75.75 0 000-1.5H8.455c.098-.195.212-.38.343-.55z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(CurrencyEuroIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 1674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function EyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.664 10.59a1.651 1.651 0 010-1.186A10.004 10.004 0 0110 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0110 17c-4.257 0-7.893-2.66-9.336-6.41zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(EyeIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 3656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function FaceSmileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.536-4.464a.75.75 0 10-1.061-1.061 3.5 3.5 0 01-4.95 0 .75.75 0 00-1.06 1.06 5 5 0 007.07 0zM9 8.5c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S7.448 7 8 7s1 .672 1 1.5zm3 1.5c.552 0 1-.672 1-1.5S12.552 7 12 7s-1 .672-1 1.5.448 1.5 1 1.5z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FaceSmileIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 8171:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function GlobeAltIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.555 5.412a8.028 8.028 0 00-3.503-2.81 14.899 14.899 0 011.663 4.472 8.547 8.547 0 001.84-1.662zM13.326 7.825a13.43 13.43 0 00-2.413-5.773 8.087 8.087 0 00-1.826 0 13.43 13.43 0 00-2.413 5.773A8.473 8.473 0 0010 8.5c1.18 0 2.304-.24 3.326-.675zM6.514 9.376A9.98 9.98 0 0010 10c1.226 0 2.4-.22 3.486-.624a13.54 13.54 0 01-.351 3.759A13.54 13.54 0 0110 13.5c-1.079 0-2.128-.127-3.134-.366a13.538 13.538 0 01-.352-3.758zM5.285 7.074a14.9 14.9 0 011.663-4.471 8.028 8.028 0 00-3.503 2.81c.529.638 1.149 1.199 1.84 1.66zM17.334 6.798a7.973 7.973 0 01.614 4.115 13.47 13.47 0 01-3.178 1.72 15.093 15.093 0 00.174-3.939 10.043 10.043 0 002.39-1.896zM2.666 6.798a10.042 10.042 0 002.39 1.896 15.196 15.196 0 00.174 3.94 13.472 13.472 0 01-3.178-1.72 7.973 7.973 0 01.615-4.115zM10 15c.898 0 1.778-.079 2.633-.23a13.473 13.473 0 01-1.72 3.178 8.099 8.099 0 01-1.826 0 13.47 13.47 0 01-1.72-3.178c.855.151 1.735.23 2.633.23zM14.357 14.357a14.912 14.912 0 01-1.305 3.04 8.027 8.027 0 004.345-4.345c-.953.542-1.971.981-3.04 1.305zM6.948 17.397a8.027 8.027 0 01-4.345-4.345c.953.542 1.971.981 3.04 1.305a14.912 14.912 0 001.305 3.04z"
  }));
}

const ForwardRef = React.forwardRef(GlobeAltIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 9104:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tips-bijles-organiseren",
      function () {
        return __webpack_require__(9555);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5275:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wave.da42d7ec.png","height":275,"width":1292,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAHlBMVEX////////////////////////////+/v7+/v7///8m/k5LAAAACnRSTlP7Eejnw7mPWzgszLouIgAAAAlwSFlzAAALEwAACxMBAJqcGAAAABZJREFUeJxjYGFlY+dkZORgAANmZgYAAk0AMGCs67cAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 4778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ CallToAction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Button.jsx
var Button = __webpack_require__(1109);
// EXTERNAL MODULE: ./src/components/Container.jsx
var Container = __webpack_require__(7527);
;// CONCATENATED MODULE: ./src/images/background-call-to-action.jpg
/* harmony default export */ var background_call_to_action = ({"src":"/_next/static/media/background-call-to-action.6a5a5672.jpg","height":2488,"width":4694,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAbEAADAAIDAAAAAAAAAAAAAAAAAQIRIQMEE//EABQBAQAAAAAAAAAAAAAAAAAAAAb/xAAYEQACAwAAAAAAAAAAAAAAAAAAAQIyQf/aAAwDAQACEQMRAD8AnRafW5F5xmVp42AB5HQ87M//2Q==","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/GlobeAltIcon.js
var GlobeAltIcon = __webpack_require__(8171);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/FaceSmileIcon.js
var FaceSmileIcon = __webpack_require__(3656);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/EyeIcon.js
var EyeIcon = __webpack_require__(1674);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/CurrencyEuroIcon.js
var CurrencyEuroIcon = __webpack_require__(8685);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/CodeBracketIcon.js
var CodeBracketIcon = __webpack_require__(4393);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/ArrowTopRightOnSquareIcon.js
var ArrowTopRightOnSquareIcon = __webpack_require__(9204);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(2637);
;// CONCATENATED MODULE: ./src/components/CallToAction.jsx







const features = [
    {
        name: "Binnen 1 dag online",
        description: "",
        icon: GlobeAltIcon
    },
    {
        name: "Stimuleert leerplezier",
        description: "",
        icon: FaceSmileIcon
    },
    {
        name: "Overzichtelijk en goedkoop",
        description: "",
        icon: EyeIcon
    },
    {
        name: "Valt onder NPO-gelden",
        description: "",
        icon: CurrencyEuroIcon
    },
    {
        name: "Maatwerk mogelijk",
        description: "",
        icon: CodeBracketIcon
    }
];
function CallToAction() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "waarom-bijlesplein",
        className: "relative overflow-hidden bg-blue-600 py-32",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                className: "absolute top-1/2 left-1/2 max-w-none -translate-x-1/2 -translate-y-1/2",
                src: background_call_to_action,
                alt: "",
                width: 2347,
                height: 1244,
                unoptimized: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-4xl text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-display text-3xl tracking-tight text-white sm:text-4xl",
                        children: "Waarom Bijlesplein?"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto max-w-7xl px-6 lg:px-8 my-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                    className: "mx-auto flex flex-wrap justify-center max-w-2xl grid-cols-1 gap-6 text-base leading-7 text-white sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-5 lg:gap-8",
                    children: features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative pl-9 whitespace-nowrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                    className: "inline font-semibold text-white",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                            className: "absolute left-1 top-1 h-5 w-5 text-white",
                                            "aria-hidden": "true"
                                        }),
                                        feature.name
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                    className: "inline",
                                    children: feature.description
                                })
                            ]
                        }, feature.name))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-4xl text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mt-5 text-lg text-white",
                            children: [
                                "Als onderwijsinstelling wil je de vraag naar bijles zelf regelen om een goed alternatief te bieden voor commerci\xeble bijlesaanbieders. Het heeft meerdere voordelen wanneer leerlingen en studenten zelf elkaar na lestijd helpen. Meer leerplezier, eigenaarschap van het eigen leren en sociale binding met elkaar. Inmiddels is bewezen dat het een positief effect heeft wanneer leerlingen van elkaar leren.",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "hover:opacity-70",
                                    href: "https://nos.nl/nieuwsuur/artikel/2408491-onderwijsraad-waarschuwt-voor-kansenongelijkheid-door-private-bijles",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        " Artikel over kansengelijkheid. ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowTopRightOnSquareIcon, {
                                            className: "inline-flex h-4 w-4 text-white mb-1"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-display text-2xl tracking-tight text-white mt-10 mb-1",
                            children: "Kansongelijkheid"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-lg text-white",
                            children: "Als onderwijsinstelling heb je ook een verantwoordelijkheid als het gaat om kansongelijkheid. Commerci\xeble bijles is alleen bereikbaar voor ouders met een goed inkomen. Met Bijlesplein stimuleer je bijles tegen een laag tarief. Het is een kant-en-klaar platform waar leerlingen en studenten een mede-scholier kunnen vinden voor bijles en waar de leerlingen en studenten hun diensten kunnen aanbieden."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "space-x-6 mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    href: "/register",
                                    color: "white",
                                    className: "mt-10",
                                    contact: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: "group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-slate-900 text-white hover:bg-slate-700 hover:text-slate-100 active:bg-slate-800 active:text-slate-300 focus-visible:outline-slate-900",
                                    href: "/demo",
                                    children: "Vraag gratis demo aan"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            href: "/tips-bijles-organiseren",
                            className: "text-white hover:opacity-70 font-semibold text-lg",
                            children: [
                                "5 tips voor betere bijles ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon, {
                                    className: "w-4 h-4 mb-0.5 inline-flex"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 2055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeaderSimple; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _images_wave_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5275);



function HeaderSimple(param) {
    let { image , top_title , title , text  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white",
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative h-60 sm:h-[27rem] overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: image,
                        alt: "Main image",
                        className: "h-full w-full object-cover"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: _images_wave_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                        alt: "Wave",
                        className: "h-24 w-full absolute -bottom-10"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto max-w-5xl py-6 px-6 sm:py-16 lg:px-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-center",
                    children: [
                        top_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-lg font-semibold text-blue-600",
                            children: top_title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-1 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl font-display",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mx-auto mt-6 max-w-2xl text-lg text-gray-600 text-left",
                            children: text
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 9555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TipsBijlesOrganiseren; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Header.jsx
var Header = __webpack_require__(7027);
// EXTERNAL MODULE: ./src/components/HeaderSimple.jsx
var HeaderSimple = __webpack_require__(2055);
// EXTERNAL MODULE: ./src/components/CallToAction.jsx + 1 modules
var CallToAction = __webpack_require__(4778);
// EXTERNAL MODULE: ./src/components/Footer.jsx
var Footer = __webpack_require__(3862);
;// CONCATENATED MODULE: ./src/images/tutoring-group.jpg
/* harmony default export */ var tutoring_group = ({"src":"/_next/static/media/tutoring-group.d3e4d059.jpg","height":2744,"width":5472,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAcEAABBQEBAQAAAAAAAAAAAAABAAIDBBEFgZH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAEx/9oADAMBAAIRAxEAPwCtexY6XUmks2ZHEhwwHBgYHj4SfEREEwz/2Q==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/pages/tips-bijles-organiseren.jsx







function TipsBijlesOrganiseren() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "5 tips om je bijles op school goed (en goedkoop) te organiseren",
                description: "Wil je bijles op school organiseren die voor iedereen toegankelijk is en echt helpt? Ontdek onze 5 tips voor een kwalitatieve en betaalbare aanpak."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSimple/* default */.Z, {
                        image: tutoring_group,
                        title: "5 tips om je bijles op school goed (en goedkoop) te organiseren",
                        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "Er wordt veel gezegd en geschreven over bijles. Het vergroot de onderwijskloof en werkt kansenongelijkheid in de hand. Er zijn tal van commerci\xeble bureaus die liever geld verdienen dan leerlingen te helpen bij de leerstof.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Genoeg reden dus om te kijken hoe het anders kan, zodat bijles wel voor iedereen toegankelijk is \xe9n op een kwalitatief hoogwaardig manier gegeven wordt. Zodat het leerlingen \xe9cht helpt. Bijlesplein heeft hiervoor 5 tips om de bijles binnen jouw school eerlijk en goed te laten slagen:"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto max-w-3xl text-base leading-7 text-gray-700 px-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-10 max-w-2xl",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl font-bold tracking-tight text-gray-900",
                                        children: "1. Stimuleer bijles tussen leerlingen onderling, tutoring werkt beter"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-6",
                                        children: "Het leren van en met medeleerlingen is bewezen effectief. Het is bewezen dat tutoring door leerlingen een positief effect heeft op de leerprestaties. Gemiddeld zelfs ongeveer vijf maanden extra leerwinst in een schooljaar (bron: Onderwijskennis.nl). Onderzoek laat zien dat zowel de leerling die als tutor optreedt als de tutee hier profijt van kan hebben. Hoewel alle typen leerlingen voordeel kan hebben van tutoring door leerlingen, is er enig bewijs dat minder goed presterende leerlingen en leerlingen met specifieke onderwijsbehoeften er het meest aan hebben."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-semibold mt-8 text-gray-900",
                                        children: "Gelijke kansen bevorderen"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "",
                                        children: "Minder goed presterende leerlingen profiteren extra van tutoring door medeleerlingen. Deze aanpak kan leerlingen helpen leerachterstanden weg te werken door onder gerichte begeleiding van een medeleerling behandelde stof te verankeren, vaardigheden te oefenen, en misverstanden vast te stellen en weg te nemen."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-2",
                                        children: "Omdat tutoring een goedkope (of zelfs gratis) vorm van bijles is, is het voor nagenoeg iedereen toegankelijk. Daarmee komen we op de volgende voorwaarde."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl font-bold tracking-tight text-gray-900 mt-8",
                                        children: "2. Ga kansenongelijkheid tegen en biedt bijles gratis of heel laagdrempelig aan"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-6",
                                        children: "Kansenongelijkheid in het onderwijs is dat leerlingen of studenten met dezelfde talenten niet dezelfde kansen krijgen. Dat heeft meerdere oorzaken. \xc9\xe9n van die oorzaken is de (beperkte) mogelijkheden van ouders. Het hangt bijvoorbeeld af van hun onderwijsniveau, het netwerk en de steun die zij krijgen van vrienden en familie. Maar ook welke (financi\xeble) mogelijkheden hebben zij om te helpen bij schoolwerk."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-8",
                                        children: "De kloof tussen leerlingen die bijles wel of niet kunnen betalen kun je wegnemen door bijles (nagenoeg) gratis aan te bieden. Dat kan door leerlingen elkaar bijles te laten geven. Iedereen heeft gelijke rechten op bijles. Niet elke ouder kan een commerci\xeble bijlesaanbieder betalen."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl font-bold tracking-tight text-gray-900 mt-8",
                                        children: "3. Zorg ervoor dat bijlesgevers/tutors handvatten hebben om goede bijles te geven, het zijn de leraren van de toekomst"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-6",
                                        children: "Leerlingen die bijles geven, doen waardevolle ervaring op. Zij zijn de leraren van de toekomst. Motiveer leerlingen daarom om het te doen. Sommige zullen een drempel ervaren, help ze daar overheen en geef ze tips en het vertrouwen."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-8",
                                        children: "Het draagt bij aan de kwaliteit van de bijles \xe9n het motiveert leerlingen hun bijles goed te geven waardoor ze wellicht enthousiast worden over het lerarenvak. Twee vliegen in \xe9\xe9n klap."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl font-bold tracking-tight text-gray-900 mt-8",
                                        children: "4. Zorg ervoor dat leerlingen elkaar eenvoudig weten te vinden"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-6",
                                        children: "Als onderwijsinstelling kun je met Bijlesplein heel eenvoudig stimuleren dat leerlingen elkaar helpen door vraag en aanbod voor bijles bij elkaar te brengen. Dat scheelt je ook nog eens heel veel administratielast zoals het bijhouden van Excellijsten en het koppelen van leerlingen. Die tijd kan worden besteed aan de kwaliteit van het onderwijs en het faciliteren van tutors."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl font-bold tracking-tight text-gray-900 mt-8",
                                        children: "5. Burgerschap bevorderen"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-6",
                                        children: "Naast het bijbrengen van kennis moeten scholen leerlingen helpen bij het opdoen van ervaringen met betrekking tot de diverse en democratische samenleving. De school wordt gezien als een soort oefenplaats, een samenleving in het klein. Op school ervaren leerlingen wat het betekent om onderdeel te zijn van een groter geheel, vol verschillende mensen. Er zijn meerdere manieren om hieraan bij te dragen en het geven van bijles aan andere leerlingen is zo’n manier om te leren over burgerschap."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-8",
                                        children: "Faciliteer daarom tutoring: niet alleen omdat het beter werkt, ook omdat het burgerschap bevordert. Door leerlingen in de rol van tutor te plaatsen, ontwikkelen zij verantwoordelijkheidsgevoel, empathie en sociale vaardigheden. Dit helpt niet alleen de tutoren zelf, maar versterkt ook de onderlinge betrokkenheid en solidariteit binnen de schoolgemeenschap. Leerlingen leren anderen kennen uit een andere omgeving dan waar ze zelf of hun vrienden zich bevinden."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-8",
                                children: "De conclusie uit bovenstaande om bijles beter te organiseren komt er vooral op neer dat je als school het geven van bijles tussen leerlingen onderling, tutoring, moet bevorderen en faciliteren. Dat heeft meerdere voordelen: het werkt beter, gaat kansenongelijkheid tegen, leerlingen doen waardevolle ervaring op, zorgt voor verbinding en het bevordert burgerschap."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-8 text-sm opacity-70 mb-8",
                                children: "Ben je nog zoekende hoe dat voor jullie school of scholengemeenschap werkt? Neem contact op met Frits Timmermans, frits@bijlesplein.nl of 0653571911."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction/* CallToAction */.J, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [695,597,774,888,179], function() { return __webpack_exec__(9104); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);